import { Component, OnInit } from '@angular/core';
import { InquiryService } from '../../../services/inquiry.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { formatDate } from '../../../misc/functions';
import { FormsModule } from '@angular/forms';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { LabelChipRendererComponent } from '../../label-chip/label-chip-renderer.componemt';
import { AbstractInquiryListComponent } from '../../abstract-inquiry-list.component';

@Component({
  selector: 'app-transfer-list',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, AgGridModule, FormsModule, LabelChipRendererComponent],
  templateUrl: './transfer-list.component.html',
  styleUrls: ['./transfer-list.component.scss']
})
export class TransferListComponent extends AbstractInquiryListComponent implements OnInit {

  columnDefs: (ColDef | ColGroupDef)[] = [
    { field: 'created_at', headerName: '作成日時', width: 165, valueFormatter: params => formatDate(params.value)},
    { field: 'title', headerName: '口座番号・振替先', flex: 1},
    { field: 'status', headerName: '状態', width: 110,  cellRenderer: LabelChipRendererComponent, cellStyle: { 'text-align': 'center' }}, // , filter: 'agTextColumnFilter', sortable: true
  ];

  override showCompletedStatus = ['完了', '取消'];
  override category = 'transfer';
  override categoryName = '振替依頼';

  constructor(
    service: InquiryService,
    snackBar: ModalSnackbarService,
    router: Router
  ) {
    super(service, snackBar, router);
  }
}
